// The two accounts money moved between, in the words every history line uses:
// "from A to B", "from A", "to B", or "" when neither is known. One copy for
// repayments and private settlements (ZEN-799, Maryse 24 Oct 2026).
export function accountsPhrase(from, to) {
  return [from && `from ${from}`, to && `to ${to}`].filter(Boolean).join(" ");
}
